import React from 'react';
import { requestUrl } from '@/constants/urls';
import NameCellWrapper from '@/components/table/NameCellWrapper';
import RequestIcon from './RequestIcon';

const RequestNameLinkCell = ({ allowTransfer, request }) => (
  <NameCellWrapper className="td-request-name" link={requestUrl(request)} name={request.name}>
    <RequestIcon allowTransfer={allowTransfer} request={request} />
    {request.name}
  </NameCellWrapper>
);

export default RequestNameLinkCell;
